module.exports = __webpack_public_path__ + "static/media/e21.a751e3a0.jpg";